export default __webpack_public_path__ + "static/media/sunwdokuz2.be88003b.jpg";